export default function MySQL_LIKE() {
  return (
    <div>
      <h2>MySQL_LIKE</h2>    </div>
  );
}